'use strict'

var objectToString = Object.prototype.toString

module.exports = function(value){
    return objectToString.apply(value) === '[object Function]'
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/i-s/src/function.js
 ** module id = 857
 ** module chunks = 0
 **/